import lang from '@/lang/middleware/pages/reviews';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const title = store.$i18n.t('title');
  const jumboTitle = store.$i18n.t('jumbotron.title');
  const subtitle = store.$i18n.t('jumbotron.subtitle');
  store.commit('jumbotron/SET_JUMBOTRON', { title: jumboTitle, subtitle, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });
};
